<template>
  <div>
    <v-stepper :value="user.step + 1">
      <v-stepper-header>
        <v-stepper-step step="1" v-if="user.step + 1 > 1" complete>{{ $t('pageIntro.header') }}</v-stepper-step>
        <v-stepper-step step="1" v-else>{{ $t('pageIntro.header') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" v-if="user.step + 1 > 2" complete>{{ $t('pageServices.header') }}</v-stepper-step>
        <v-stepper-step step="2" v-else>{{ $t('pageServices.header') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" v-if="user.step + 1 > 3" complete>{{ $t('pageDateTime.header') }}</v-stepper-step>
        <v-stepper-step step="3" v-else>{{ $t('pageDateTime.header') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" v-if="user.step + 1 > 4" complete>{{ $t('pageContact.header') }}</v-stepper-step>
        <v-stepper-step step="4" v-else>{{ $t('pageContact.header') }}</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'Progress',
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
